<template>
  <div v-if="data" class="orders">
    <Header2 :companyInfo="comnpany_info" />
    <div class="completed common">
      <div class="img">
        <img src="../assets/images/completed.png" alt="" />
        <div>
          <div>您已完成付款</div>
          <div>企业年报申报信息已完成提交</div>
        </div>
      </div>
      <div class="remind">
        <div class="title">服务提醒:</div>
        <div class="text">
          纽必企服年报代办将在收到您的信息提交后，72小时内为您的企业进行年报代办。如遇申报问题，纽必企服客服将会在第一时间与您联系，请保持电话畅通。
        </div>
      </div>
    </div>
    <div class="customerService common">
      <div class="title">
        <img src="../assets/images/kefu.png" alt="" />
        <span>咨询客服</span>
      </div>
      <div class="contactInformation">
        <div @click="make_phone" class="photo">
          <img src="../assets/images/photo.png" alt="" />
          <span>电话</span>
          <span>点击拨号</span>
        </div>
        <div @click="make_wx" class="wx">
          <img src="../assets/images/wx.png" alt="" />
          <span>微信</span>
          <span>点击咨询</span>
        </div>
      </div>
    </div>
    <Footer />
    <kefu />
  </div>
</template>
<script>
import Header2 from "../components/header2";
import footer from "../components/footer.vue";
import { pay_list } from "../api/request";
import kefu from "../components/kefu.vue";
import {MessageBox} from "mint-ui";
export default {
  name: "", //
  data() {
    return {
      data: "", //支付信息
      comnpany_info: {}, //公司信息
    };
  },
  components: {
    Footer: footer,
    Header2,
    kefu,
  },
  props: {},
  methods: {
      yy(){
          MessageBox.confirm('',{
              title:'提示',
              message:'支付完成了吗？',
              confirmButtonText:'支付完成',
              cancelButtonText:'未支付'
          }).then(action => {
              if (action == 'confirm'){
                  this.pay_list()
              }
          }).catch(error => {
              if (error == 'cancel'){
                  this.pay_list()
              }
          })
      },
    //获取支付信息 如果没有跳回支付页
    pay_list() {
      pay_list({
        random: localStorage.getItem("nbnbRandom"),
      }).then((res) => {
        this.data = res.data;
          console.log( '进入订单页接口返回'+res.data)
        if (!this.data) {
          this.$router.push({ path: "/payment", query: { state: localStorage.getItem("nbnbRandom") } });
        }
      });
    },
    //拨打电话
    make_phone() {
      window.location.href = "tel://" + "400-056-5663";
    },
    //企业微信
    make_wx() {
      window.location.href = "https://work.weixin.qq.com/kfid/kfcd135fd5b4ca66b32";
    },
  },
  created() {
    this.comnpany_info = JSON.parse(localStorage.getItem("nbnbcomnpany_info"));
    //获取支付信息
    this.yy();
    //获取公司信息

  },
  mounted() {},
  destroyed() {},
};
</script>
<style lang="less" scoped>
/* by wdl */
.orders {
  .common {
    background: #fff;
    box-shadow: 0px 2px 5px 0px #a7d7fb;
    width: 359px;
    margin: 15px auto 0;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 10px 10px 15px;
  }
  .completed {
    .img {
      text-align: center;
      font-size: 18px;
      font-weight: bolder;
      line-height: 25px;
      img {
        width: 100px;
        height: 100px;
        display: block;
        margin: 0 auto;
      }
    }
  }
  .remind {
    margin-top: 20px;
    .title {
      color: #df1a1a;
      font-size: 16px;
      font-weight: bolder;
      margin-bottom: 5px;
    }
    .text {
      line-height: 25px;
      text-indent: 2em;
      font-size: 14px;
      letter-spacing: 1px;
      text-align: justify;
    }
  }
  .customerService {
    margin-bottom: 15px;
    .title {
      font-size: 16px;
      font-weight: bolder;
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        margin-right: 3px;
      }
    }
    .contactInformation {
      font-size: 13px;
      font-weight: bolder;
      display: flex;
      justify-content: center;
      margin-top: 15px;
      img {
        width: 18px;
        height: 18px;
        margin-right: 5px;
      }
      .photo,
      .wx {
        display: flex;
        align-items: center;
        span:nth-of-type(1) {
          margin-right: 5px;
        }
        span:nth-of-type(2) {
          padding: 2px 5px;
          color: #fff;
        }
      }
      .photo {
        img:nth-of-type(1) {
          width: 18px;
          height: 15px;
        }
        span:nth-of-type(2) {
          background: #df1a1a;
          border-radius: 5px;
        }
      }
      .wx {
        margin-left: 30px;
        span:nth-of-type(2) {
          background: #06a819;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>
